import { Checkbox, FormControlLabel } from '@mui/material';
import classNames from 'classnames';
import css from './modal.module.scss';

export interface MultiAnswerProps {
  name: string;
  label: string;
  isSelected: boolean;
  onSelect: (items: string) => void;
  correctClass: boolean;
}

const MultiAnswer = ({ name, label, isSelected, onSelect, correctClass }: Readonly<MultiAnswerProps>) => {
  return (
    <FormControlLabel
      onClick={(event: React.MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        onSelect(name);
      }}
      className={classNames(css.answer, { [css.selected]: isSelected, [css.correct]: correctClass })}
      control={<Checkbox checked={isSelected} />}
      label={label}
    />
  );
};

export default MultiAnswer;
